import { MetaDataFieldIds } from '@upflowy/types';
import UAParser from 'ua-parser-js';

import { ILocation } from '../providers/app-provider';

export function getMetaData({ location }: { location: ILocation }) {
  const navData = UAParser(navigator.userAgent);
  const meta: Partial<Record<MetaDataFieldIds, unknown>> = {
    'browser.name': navData.browser.name,
    'operatingSystem.version': navData.os.version,
    'operatingSystem.name': navData.os.name,
    'device.type': navData.device.type ?? 'desktop',
    'location.city': location?.city,
    'location.region': location?.region,
    'location.country': location?.country,
  };
  return Object.entries(meta).reduce(
    (p, [key, value]) => ({
      ...p,
      [`meta.${key}`]: value,
    }),
    {},
  );
}
